import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import AnalyticsWebClient, { envType, originType, userType } from '@atlassiansox/analytics-web-client';
var ANALYTICS_PRODUCT = 'embeddedConfluence';
var defaultOrgId = '';
var orgIdQuery = "query OrgId($hostNames: [String!]) {\n    tenantContexts(hostNames: $hostNames) {\n      orgId\n    }\n  }";
var getAGGOrgId = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(hostname) {
    var orgId, prefix, _result$data$tenantCo, _result$data, response, result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          orgId = defaultOrgId; // default value set to empty string for orgid when no orgid exists
          prefix = "".concat(window.location.protocol, "//").concat(hostname || window.location.hostname);
          _context.prev = 2;
          _context.next = 5;
          return fetch("".concat(prefix, "/gateway/api/graphql"), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              query: orgIdQuery,
              variables: {
                hostNames: [hostname]
              }
            })
          });
        case 5:
          response = _context.sent;
          _context.next = 8;
          return response.json();
        case 8:
          result = _context.sent;
          orgId = (_result$data$tenantCo = (_result$data = result.data) === null || _result$data === void 0 || (_result$data = _result$data.tenantContexts[0]) === null || _result$data === void 0 ? void 0 : _result$data.orgId) !== null && _result$data$tenantCo !== void 0 ? _result$data$tenantCo : defaultOrgId;
          _context.next = 15;
          break;
        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](2);
          // eslint-disable-next-line no-console
          console.error("Error fetching orgId from ".concat(hostname, "/gateway/api/graphql"));
        case 15:
          return _context.abrupt("return", orgId);
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 12]]);
  }));
  return function getAGGOrgId(_x) {
    return _ref.apply(this, arguments);
  };
}();

// Define default analytic-web-client environment config for now
var getAnalyticsEnv = function getAnalyticsEnv(hostname) {
  if (hostname.includes('localhost')) {
    return envType.LOCAL;
  }
  if (hostname.includes('jira-dev')) {
    return envType.DEV;
  }
  return envType.PROD;
};
var analyticsClient;
var getUserInfo = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(hostname, userInfo) {
    var prefix, res, resJson, account_id, account_type;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!userInfo) {
            _context2.next = 4;
            break;
          }
          return _context2.abrupt("return", {
            userId: userInfo === null || userInfo === void 0 ? void 0 : userInfo.userId,
            userIdType: userInfo === null || userInfo === void 0 ? void 0 : userInfo.userIdType
          });
        case 4:
          prefix = "".concat(window.location.protocol, "//").concat(hostname || window.location.hostname);
          _context2.next = 7;
          return fetch("".concat(prefix, "/gateway/api/me"));
        case 7:
          res = _context2.sent;
          _context2.next = 10;
          return res.json();
        case 10:
          resJson = _context2.sent;
          account_id = resJson.account_id, account_type = resJson.account_type;
          return _context2.abrupt("return", account_type === 'atlassian' ? {
            userId: account_id,
            userIdType: userType.ATLASSIAN_ACCOUNT
          } : undefined);
        case 13:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getUserInfo(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();
export var getAnalyticsWebClient = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref3) {
    var hostname, userInfo, orgId, fetchedUserInfo;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          hostname = _ref3.hostname, userInfo = _ref3.userInfo;
          if (analyticsClient) {
            _context3.next = 23;
            break;
          }
          analyticsClient = new AnalyticsWebClient({
            product: ANALYTICS_PRODUCT,
            env: getAnalyticsEnv(hostname || window.location.hostname),
            origin: originType.WEB
          });
          _context3.prev = 3;
          _context3.next = 6;
          return getAGGOrgId(hostname);
        case 6:
          orgId = _context3.sent;
          analyticsClient.setOrgInfo(orgId);
          _context3.next = 13;
          break;
        case 10:
          _context3.prev = 10;
          _context3.t0 = _context3["catch"](3);
          // eslint-disable-next-line no-console
          console.error(_context3.t0); // orgId is not set when undefined or empty string based on current impl of setOrgInfo
        case 13:
          _context3.prev = 13;
          _context3.next = 16;
          return getUserInfo(hostname, userInfo);
        case 16:
          fetchedUserInfo = _context3.sent;
          if (fetchedUserInfo) {
            analyticsClient.setUserInfo(fetchedUserInfo.userIdType, fetchedUserInfo.userId);
          }
          _context3.next = 23;
          break;
        case 20:
          _context3.prev = 20;
          _context3.t1 = _context3["catch"](13);
          // eslint-disable-next-line no-console
          console.error("Error fetching userInfo from ".concat(hostname, "/gateway/api/me"));
        case 23:
          return _context3.abrupt("return", analyticsClient);
        case 24:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[3, 10], [13, 20]]);
  }));
  return function getAnalyticsWebClient(_x4) {
    return _ref4.apply(this, arguments);
  };
}();